export var ASSIGNMENT_REPOSITORY = 'ASSIGNMENT_REPOSITORY';